const siteConfig = {
  revalidate: 60,
  phone: "+358 40 123 4567",
  email: "info@elainlaakariasemasinni.fi",
  bookingUrl:
    "https://nettiaika.dyndns.org/web/booking_types.html?clinic_id=Elainlaakariasema_Sinni_Oy",
  siteName: "Eläinlääkäriasema Sinni",
  siteUrl: "https://elainlaakariasemasinni.fi",
  bookButton: "Varaa aika",
  address: {
    streetAddress: "Klinikankatu 1",
    addressLocality: "Rovaniemi",
    postalCode: "96300",
  },
  registrationNumber: "3495123-4",
  social: {
    instagram: "https://www.instagram.com/elainlaakariasemasinni/",
  },
  navigation: [
    { label: "Etusivu", url: "/" },
    { label: "Palvelumme", url: "/palvelumme" },
    { label: "Meistä", url: "/meista" },
    { label: "Hinnasto", url: "/hinnasto" },
    { label: "Yhteystiedot", url: "/yhteystiedot" },
    { label: "Ajanvaraus", url: "/ajanvaraus" },
  ],
  content: {
    followUs: "Seuraa meitä",
    openToday: "Avoinna tänään:",
  },
  meta: {
    defaultTitle: "Eläinlääkäriasema Sinni – Hoitoa lemmikeille Rovaniemellä",
    defaultDescription:
      "Tarjoamme asiantuntevaa ja ystävällistä eläinlääkäripalvelua Rovaniemellä. Ajanvaraus helposti verkossa – tervetuloa Eläinlääkäriasema Sinniin!",
    siteUrl: "https://www.elainlaakariasemasinni.fi",
    ogImage: "/elainlaakariasema-sinni-og.jpg",
  },
};
export default siteConfig;
